import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import { MetaType } from "core/enums";
import { FormGroup } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { CategoryField } from "components/CasesTable/MoreFilter/widgets/CategoryField";
import { DateField } from "components/CasesTable/MoreFilter/widgets/DateField";
import { NumericField } from "components/CasesTable/MoreFilter/widgets/NumericField";
import { TextSearchField } from "components/CasesTable/MoreFilter/widgets/TextField";

export function AttributeFilterField({
  attributeData,
  setFieldValue,
  filters
}) {
  const attributeName = attributeData?.name;
  const attributeDataType = attributeData?.data_type;
  const categoricalValues = attributeData?.data_value_details;

  const onSetField = useCallback(
    value => {
      if (!!value && value !== "") {
        setFieldValue(value, attributeName);
      } else {
        setFieldValue(null, attributeName);
      }
    },
    [attributeName, setFieldValue]
  );

  const onSetRangeField = useCallback(
    values => {
      const value = values
        .map((value, index) => {
          return {
            type_name: `${attributeName}__${index === 0 ? "gte" : "lte"}`,
            name: value ?? null
          };
        })
        .filter(value => value.name);
      if (!!value && value !== "") {
        setFieldValue(value, attributeName);
      } else {
        setFieldValue(null, attributeName);
      }
    },
    [attributeName, setFieldValue]
  );

  const AttributeEditField = attributeDataType => {
    switch (attributeDataType?.id) {
      case MetaType.CATEGORY:
        return (
          <CategoryField
            attributeName={attributeName}
            categoricalValues={categoricalValues}
            filters={filters}
            onSetField={onSetField}
          />
        );
      case MetaType.DATE:
        return (
          <DateField
            attributeName={attributeName}
            filters={filters}
            onSetField={onSetField}
          />
        );
      case MetaType.NUMBER:
        const from = filters[attributeName]?.find(({ type_name }) =>
          type_name?.includes("__gte")
        );
        const to = filters[attributeName]?.find(({ type_name }) =>
          type_name?.includes("__lte")
        );

        return (
          <NumericField
            attributeName={attributeName}
            fromValue={from?.name ?? null}
            toValue={to?.name ?? null}
            onChangeFromValue={fromValue =>
              onSetRangeField([fromValue, to?.name])
            }
            onChangeToValue={toValue => onSetRangeField([from?.name, toValue])}
            onChangeBothValue={(fromValue, toValue) =>
              onSetRangeField([fromValue, toValue])
            }
          />
        );
      default:
        return (
          <TextSearchField
            attributeName={attributeName}
            filters={filters}
            onSetField={onSetField}
          />
        );
    }
  };

  return (
    <FormGroup>
      <FormWrap>{AttributeEditField(attributeDataType)}</FormWrap>
    </FormGroup>
  );
}

const FormWrap = styled(FormControl)`
  min-width: 50%;
`;

AttributeFilterField.propTypes = {
  attributeData: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
  filters: PropTypes.object.isRequired
};
